export default "__VITE_ASSET__CM$romxu__"